var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestPickupGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0C2.33579 0 2 0.335786 2 0.75C2 1.16421 2.33579 1.5 2.75 1.5H5V16.9798C3.68431 17.483 2.75 18.7574 2.75 20.25C2.75 22.183 4.317 23.75 6.25 23.75C8.09894 23.75 9.61302 22.3163 9.74121 20.5H18.4393L20.7197 22.7803C21.0126 23.0732 21.4874 23.0732 21.7803 22.7803C22.0732 22.4874 22.0732 22.0126 21.7803 21.7197L19.2803 19.2197C19.1397 19.079 18.9489 19 18.75 19H9.52019C9.43009 18.7644 9.31526 18.5411 9.17889 18.3331H18.25C18.5261 18.3331 18.75 18.1093 18.75 17.8331V9.83313C18.75 9.55699 18.5261 9.33313 18.25 9.33313H15.75V4.25323C15.75 3.97709 15.5261 3.75323 15.25 3.75323H8.25C7.97386 3.75323 7.75 3.97709 7.75 4.25323V9.83313V10.3331V17.0868C7.36656 16.9047 6.94475 16.7902 6.5 16.7588V0.75C6.5 0.335786 6.16421 0 5.75 0H2.75ZM9.25 9.33313V5.25323H14.25V9.33313H9.25ZM9.25 10.8331V16.8331H17.25V10.8331H15.25H9.25ZM8.25 20.25C8.25 21.3546 7.35457 22.25 6.25 22.25C5.14543 22.25 4.25 21.3546 4.25 20.25C4.25 19.1454 5.14543 18.25 6.25 18.25C7.35457 18.25 8.25 19.1454 8.25 20.25Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPickupGrey);
export default __webpack_public_path__ + "static/media/RequestPickupGrey.818dd2fede12e47f850f5617867610a7.svg";
export { ForwardRef as ReactComponent };